import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";
import { userManager } from "@/auth.service";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "default",
    component: Home,
  },
  {
    path: "/my-applications",
    name: "myapplications",
    component: () =>
      import(
        /* webpackChunkName: "myapplications" */ "../views/Applications/ApplicationList.vue"
      )
  },
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile/Profile.vue")
  },
  {
    path: "/settings",
    name: "apps",
    component: () =>
      import(/* webpackChunkName: "apps" */ "../views/Settings/Settings.vue")
  },

  {
    path: "/sessions",
    name: "sessions",
    component: () =>
      import(/* webpackChunkName: "sessions" */ "../views/Sessions/SessionList.vue")
  },
  {
    path: "/deviceCompromised/:id",
    name: "deviceCompromised",
    component: () =>
      import(/* webpackChunkName: "deviceCompromised" */ "../views/Sessions/DeviceCompromised.vue")
  },
  {
    path: "/authfactors",
    name: "authfactors",
    component: () =>
      import(/* webpackChunkName: "authfactors" */ "../views/AuthFactors/AuthFactorList.vue")
  },
  {
    path: "/callback",
    name: "callback",
    component: () =>
      import(
        /* webpackChunkName: "oid-callback" */ "../components/OpenIDCallback.vue"
      )
  },
  {
    path: "*",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "core" */ "@/views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "is-active",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== "callback") {
    localStorage.setItem("path", to.path);
    if(!store.getters.isAuthenticated)  {
      userManager.signinRedirect().catch(err => {
        console.log(err);
      });
    }  
  }
  next();
});

export default router;
